import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { getAssetIds } from '../_helpers/documentData'
import { useChildrenServiceOrders } from './ChildrenServiceOrderLoader'
import { useServiceOrder } from './ServiceOrderLoader'

const Context = React.createContext([])
const { Provider } = Context
export const useAssets = () => React.useContext(Context)?.assets || []

const QUERY = gql`
  query Assets($filter: AssetFilter) {
    assets(filter: $filter) {
      id
      name
      fieldValues {
        id
        value
        field {
          id
          name
        }
      }
    }
  }
`

// Carrega os campos adicionais (ex.: endereço) do terminal e do berço de tratamento
const AssetsLoader = ({ children }) => {
  const serviceOrder = useServiceOrder()
  const childrenServiceOrders = useChildrenServiceOrders()
  const replies = [serviceOrder, ...childrenServiceOrders].flatMap(so => so.replies || [])
  const ids = getAssetIds(replies)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ids, includeDisabled: true } },
    client: placesClient,
    skip: !ids.length
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsLoader
